import React, { useState } from 'react'

// mui
import { Container, Grid, Typography } from '@mui/material'

// collections
import JobListWithSearch from './collections/JobListWithSearch/JobListWithSearch.collection'

// forms
import CreateJobFormController from './forms/createJob/CreateJob.form.controller'

// wrapper
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// graphql
import { GET_ALL_JOBS_WITH_FULL_DETAIL } from '../../../graphql/job/job.queries'

export default function JobList({ ...pageProps }) {

    // modals
    const [showAddModal, setShowAddModal] = useState(false)

    return(<div id="JobList">
        <CreateJobFormController 
            visible={showAddModal}
            closeForm={() => setShowAddModal(false)}
        />

        <Container maxWidth disableGutters sx={{ marginBottom: 4}}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={6}><Typography variant="h2">Jobs</Typography></Grid>
            </Grid>
        </Container>
       
        <WithGqlQuery
            component={JobListWithSearch}
            query={GET_ALL_JOBS_WITH_FULL_DETAIL}
            fetchPolicy={"network-only"}
            onAddClick={() => setShowAddModal(true)}
            pageProps={pageProps}
        />
    </div>)
}